import { forwardRef, useLayoutEffect, useMemo, useState } from "react";
import styles from "./Profiles.module.css";
import { DataGrid, gridClasses, GRID_CHECKBOX_SELECTION_COL_DEF } from "@mui/x-data-grid";
import { ShoppingBag } from "@mui/icons-material";
import { Typography } from "@mui/material";

const profileNameRenderer = ({id, value}) => {
  return ( 
    <>
    <ShoppingBag color="secondary" sx={{mr: 1}}/>
    <Typography sx={{fontSize: "1.1rem"}}>{value}</Typography>
    </>
  );
};

const Profiles = forwardRef(({apiRef, items, onChange}, ref) => {

  const [selectedRows, setSelectedRows] = useState([]);

  useLayoutEffect( () => { 
    return () => {
      onChange([]);
    }
  }, []);

  const onModelChange = (newSelectedRows) => {
    setSelectedRows(newSelectedRows);
    onChange(newSelectedRows);
  };

  const columns = useMemo( () => [
      {field: 'name', flex: 1, renderCell: profileNameRenderer, display: 'flex'},
      {...GRID_CHECKBOX_SELECTION_COL_DEF}  
    ], [items]
  );

  return (
    <div ref={ref}>
      <DataGrid
        editMode="row"
        apiRef={apiRef}
        className={styles.profiles}
        rows={items}
        rowSelectionModel={selectedRows}
        localeText={{noRowsLabel: "Профилей пока нет"}}
        columns={columns}
        columnHeaderHeight={1}
        checkboxSelection
        disableColumnResize
        disableColumnMenu
        disableRowSelectionOnClick
        disableMultipleRowSelection
        onRowSelectionModelChange={onModelChange}
        hideFooter
        sx={{
          [`& .${gridClasses.cell}:focus, & .${gridClasses.cell}:focus-within`]: {
            outline: 'none',
          },
          [`& .${gridClasses.columnHeader}, & .MuiInputBase-root`]: {
            overflowX: 'unset'
          },
          [`& .${gridClasses.cell}.${gridClasses["cell--editing"]}:focus, & .${gridClasses.cell}.${gridClasses["cell--editing"]}:focus-within`]: {
            outline: 'none'
          }
        }}
      />
      
    </div>
  );
});

export default Profiles;